// luxury-hero-carousel.js
class LuxuryCarousel extends HTMLElement {
  constructor() {
    super();
    this.slides = Array.from(this.querySelectorAll('.luxury-carousel__slide'));
    this.dots = Array.from(this.querySelectorAll('.luxury-carousel__dot'));
    this.prevBtn = this.querySelector('.luxury-carousel__arrow--prev');
    this.nextBtn = this.querySelector('.luxury-carousel__arrow--next');
    
    this.autoplaySpeed = parseInt(this.dataset.autoplaySpeed) * 1000;
    this.currentIndex = 0;
    this.autoplayTimer = null;
    
    this.init();
  }

  init() {
    if (this.slides.length <= 1) {
      if (this.prevBtn) this.prevBtn.style.display = 'none';
      if (this.nextBtn) this.nextBtn.style.display = 'none';
      const controls = this.querySelector('.luxury-carousel__controls');
      if (controls) controls.style.display = 'none';
      this.playVideo(0);
      return;
    }

    if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.prev());
    if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.next());
    
    this.dots.forEach((dot, index) => {
      dot.addEventListener('click', () => this.goToSlide(index));
    });

    this.playVideo(this.currentIndex);
    this.startAutoplay();
  }

  startAutoplay() {
    if (!this.autoplaySpeed) return;
    this.stopAutoplay();
    this.autoplayTimer = setInterval(() => this.next(), this.autoplaySpeed);
  }

  stopAutoplay() {
    if (this.autoplayTimer) clearInterval(this.autoplayTimer);
  }

  pauseVideo(index) {
    const slide = this.slides[index];
    const video = slide.querySelector('video');
    if (video) video.pause();
  }

  playVideo(index) {
    const slide = this.slides[index];
    const video = slide.querySelector('video');
    if (video) {
      video.currentTime = 0;
      video.play().catch(() => {});
    }
  }

  goToSlide(index) {
    if (index === this.currentIndex) return;
    
    this.pauseVideo(this.currentIndex);
    this.slides[this.currentIndex].classList.remove('is-active');
    if (this.dots.length) this.dots[this.currentIndex].classList.remove('is-active');

    this.currentIndex = index;

    this.slides[this.currentIndex].classList.add('is-active');
    if (this.dots.length) this.dots[this.currentIndex].classList.add('is-active');
    this.playVideo(this.currentIndex);
    
    this.startAutoplay(); // Reset timer
  }

  next() {
    let nextIndex = this.currentIndex + 1;
    if (nextIndex >= this.slides.length) nextIndex = 0;
    this.goToSlide(nextIndex);
  }

  prev() {
    let prevIndex = this.currentIndex - 1;
    if (prevIndex < 0) prevIndex = this.slides.length - 1;
    this.goToSlide(prevIndex);
  }
}

customElements.define('luxury-hero-carousel', LuxuryCarousel);
